// extracted by mini-css-extract-plugin
module.exports = {"root":"_22c52fa1b683d445a53c623ba72ee7df","img":"da43a595dcb016e592e2ae0493a0a096","character":"_2e030e29010d62511c2fe84efdbb6251"};